import { Chip } from "@mui/material";
import { AppState } from "../types/appIntegration.types";
import { APP_STATUS_CONFIG } from "../constants/appStatusChip.config";

interface Props {
  status: AppState;
}

export const StatusChip = ({ status }: Props) => {
  const config = APP_STATUS_CONFIG[status];

  return (
    <Chip
      size="small"
      label={config.label}
      color={config.color}
      variant={config.variant ?? "filled"}
      sx={{
        fontSize: "0.7rem",
        height: 22,
        fontWeight: 600,
      }}
    />
  );
};
